import getSelectedTableView from '../../utils/getSelectedTableView';
import unselectAll from './unselectAll';
import { action } from 'satcheljs/lib/legacy';

export default action('multiSelectCancel', { datapoint: { name: 'CancelMultiSelect' } })(
    function multiSelectCancel() {
        // Unselect all first
        unselectAll();
        const tableView = getSelectedTableView();
        tableView.isInCheckedMode = false;
    }
);
